'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _watchAppNotifier = require('common/components/mixins/watch-app-notifier');

var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);

var _member = require('./member');

var _member2 = _interopRequireDefault(_member);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _uploadCsvButton = require('./upload-csv-button');

var _uploadCsvButton2 = _interopRequireDefault(_uploadCsvButton);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { return step("next", value); }, function (err) { return step("throw", err); }); } } return step("next"); }); }; }

var _ref = _jsx('br', {});

var _ref2 = _jsx(_button2['default'], {
    buttonText: 'Cancel',
    buttonColor: 'white',
    buttonTextColor: 'grasshopper',
    buttonHoverColor: 'grasshopper',
    buttonClass: 'm-button-butmit close',
    buttonBorderColor: 'grasshopper',
    buttonHoverTextColor: 'white'
});

var _ref3 = _jsx(_button2['default'], {
    buttonText: 'Close',
    buttonColor: 'grasshopper',
    buttonHoverColor: 'ashen',
    buttonClass: 'm-button-butmit close',
    buttonHoverTextColor: 'white'
});

var TeamPage = _react2['default'].createClass({
    displayName: 'TeamPage',


    /**
    */

    mixins: [_watchAppNotifier2['default']],

    /**
    */

    propTypes: {
        "csrfToken": _react2['default'].PropTypes.string
    },

    /**
    */

    getInitialState: function getInitialState() {
        var app = this.props.app;
        return {
            app: app,
            user: app.user,
            team: app.user.getTeam(),
            teamMembers: app.user.getTeam().getMembers()
        };
    },

    /**
    */

    toggleEditTeamName: function toggleEditTeamName() {
        this.setState({ editTeamName: !this.state.editTeamName }, function () {
            var node = this.refs.teamNameInput;
            node.focus();
            node.setSelectionRange(this.state.team.name.length, this.state.team.name.length);
        }.bind(this));
    },

    /**
    */

    saveTeamName: function saveTeamName(event) {
        var teamName = this.refs.teamNameInput.value.trim();
        if (teamName.length === 0) teamName = "Untitled Team";
        this.state.team.set("name", teamName);
        this.setState({ editTeamName: false });

        console.log(__filename, 'save');
        this.state.team.save();
        event.preventDefault();
    },

    /**
    */

    addTeamMember: function () {
        var ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(event) {
            var ref, teamMemberEmail, i;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            this.setState({ 'error': void 0 });

                            event.preventDefault();

                            if (!this.state.csvFile) {
                                _context.next = 12;
                                break;
                            }

                            _context.prev = 3;
                            _context.next = 6;
                            return this.state.team.importTeamMembers(this.state.csvFile);

                        case 6:
                            _context.next = 11;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](3);

                            this.setState({ 'error': _context.t0 });

                        case 11:
                            return _context.abrupt('return');

                        case 12:
                            ref = this.refs.newMemberEmailAddress;
                            teamMemberEmail = ref.value || "";

                            // TODO - move this to model

                            if (_hfReactHelper2['default'].isValidEmailAddress(teamMemberEmail)) {
                                _context.next = 16;
                                break;
                            }

                            return _context.abrupt('return', this.setState({
                                'error': new Error("Please enter a valid email address!")
                            }));

                        case 16:
                            i = 0;

                        case 17:
                            if (!(i < this.state.teamMembers.length)) {
                                _context.next = 23;
                                break;
                            }

                            if (!(this.state.teamMembers.at(i).emailAddress === teamMemberEmail)) {
                                _context.next = 20;
                                break;
                            }

                            return _context.abrupt('return', this.setState({
                                'error': new Error("That user is already on your team.")
                            }));

                        case 20:
                            i++;
                            _context.next = 17;
                            break;

                        case 23:
                            if (!this.state.team.pastTeamMemberLimit()) {
                                _context.next = 29;
                                break;
                            }

                            if (!this.state.team.enterpriseProRateAmount) {
                                _context.next = 28;
                                break;
                            }

                            return _context.abrupt('return', this.state.app.actions.ui.showModal(_jsx('div', {
                                className: 'l-new-modal'
                            }, void 0, _jsx('div', {
                                className: 'l-new-modal--content-wrap'
                            }, void 0, _jsx('div', {
                                className: 'l-new-modal--title'
                            }, void 0, 'New seat needed'), _jsx('div', {
                                className: 'l-new-modal--content'
                            }, void 0, _jsx('p', {}, void 0, 'To invite this person to your team, please purchase a new seat.'), _jsx('p', {}, void 0, 'Each seat you add will be billed at your rate of ', _jsx('b', {}, void 0, this.state.team.enterprisePrice, '/', this.state.team.enterprisePeriod), '.', _ref, 'This seat will be prorated at ', _jsx('b', {}, void 0, this.state.team.enterpriseProRateAmount), ' for this ', this.state.team.enterprisePeriod, '.')), _jsx('div', {
                                className: 'l-new-modal--actions'
                            }, void 0, _ref2, _jsx(_button2['default'], {
                                buttonText: 'Continue',
                                onClick: this._addTeamMember.bind(this, teamMemberEmail, ref),
                                buttonColor: 'grasshopper',
                                buttonHoverColor: 'ashen',
                                buttonClass: 'm-button-butmit close',
                                buttonHoverTextColor: 'white'
                            })))), { 'showCloseButton': false }, 'new-enterprise-seat'));

                        case 28:
                            return _context.abrupt('return', this.setState({
                                error: new Error("You need to upgrade to add more team members.")
                            }));

                        case 29:

                            this._addTeamMember(teamMemberEmail, ref);

                        case 30:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[3, 8]]);
        }));

        function addTeamMember(_x) {
            return ref.apply(this, arguments);
        }

        return addTeamMember;
    }(),

    /**
    */

    _addTeamMember: function () {
        var ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(teamMemberEmail, ref) {
            var member, site;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:

                            this.setState({ 'addingTeamMember': true });

                            _context2.prev = 1;
                            _context2.next = 4;
                            return this.state.team.addMember({
                                emailAddress: teamMemberEmail,
                                csrfToken: this.props.csrfToken
                            });

                        case 4:
                            member = _context2.sent;
                            _context2.next = 10;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](1);
                            return _context2.abrupt('return', this.setState({ error: _context2.t0, addingTeamMember: false }));

                        case 10:

                            this.setState({
                                error: void 0,
                                addingTeamMember: false
                            });

                            // Clear the input field
                            ref.value = "";

                            console.log(member, member.pending);

                            // don't do now - need copy text
                            if (member && member.pending) {
                                site = _hfReactHelper2['default'].isHelloSign() ? "HelloSign" : "HelloFax";

                                this.state.app.actions.ui.showModal(_jsx('div', {
                                    className: 'l-new-modal'
                                }, void 0, _jsx('div', {
                                    className: 'l-new-modal--content-wrap'
                                }, void 0, _jsx('div', {
                                    className: 'l-new-modal--title'
                                }, void 0, 'Existing Account'), _jsx('div', {
                                    className: 'l-new-modal--content'
                                }, void 0, _jsx('p', {}, void 0, teamMemberEmail, ' already has a ', site, ' account. We have sent them an invitation to join your team.')), _jsx('div', {
                                    className: 'l-new-modal--actions'
                                }, void 0, _ref3))), { 'showCloseButton': false }, 'invite-existing-account');
                            }

                        case 14:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 7]]);
        }));

        function _addTeamMember(_x2, _x3) {
            return ref.apply(this, arguments);
        }

        return _addTeamMember;
    }(),

    /**
    */

    onCSVFile: function onCSVFile(file) {
        this.setState({ csvFile: file });
    },

    /**
    */

    render: function render() {

        var canModifyTeam = this.state.team.isOwner && this.state.team.maxSize > 1;
        var sections = {};

        if (this.state.team.maxSize < Infinity) {
            sections.bucketUsage = _jsx('p', {
                className: 'bucket-usage'
            }, void 0, 'You have used ', _jsx('span', {
                id: 'team_size_display'
            }, void 0, this.state.team.size), ' of ', this.state.team.maxSize, ' team seats.', _jsx('a', {
                className: 'team-page-more-seats',
                href: '/info/pricing'
            }, void 0, 'UPGRADE FOR MORE SEATS'));
        }

        // still not done - don't impl for now (CC)
        /*
        if (this.state.csvFile) {
        sections.uploadCSVButton = <form className="csv_import">
        <span onClick={this.onCSVFile.bind(this, void 0)} id="csv_import_link">Cancel</span>
        </form>
        } else {
        sections.uploadCSVButton = <UploadCSVButton onFile={this.onCSVFile} />;
        }
        */

        if (canModifyTeam) {
            sections.editTeamName = _jsx('a', {
                href: '#',
                id: 'edit_team_name_link',
                onClick: this.toggleEditTeamName
            }, void 0, _jsx('img', {
                className: 'team-page-edit-title',
                src: require("./team_edit_icon_@2x.png")
            }));

            sections.addTeamMember = _jsx('div', {}, void 0, sections.bucketUsage, _jsx('form', {
                className: 'add_team_member',
                onSubmit: this.addTeamMember
            }, void 0, _react2['default'].createElement('input', {
                ref: 'newMemberEmailAddress',
                type: 'text', name: 'new_member_email_address',
                placeholder: this.state.csvFile ? this.state.csvFile.name : void 0,
                className: 'required email new_member_email_address no_focus',
                disabled: !!this.state.csvFile || this.state.addingTeamMember }), _jsx('div', {
                id: 'add-team-member-submit-react-holder'
            }, void 0, _jsx(_button2['default'], {
                buttonId: this.state.csvFile ? "csv_import_submit" : "add_team_member_submit",
                buttonText: this.state.csvFile ? "Invite People" : this.state.addingTeamMember ? "Inviting..." : "Invite",
                buttonColor: 'grasshopper',
                buttonHoverColor: 'ashen',
                buttonClass: 'm-button-butmit',
                buttonHoverTextColor: 'white'
            }))), sections.uploadCSVButton);
        } else if (this.state.team.isOwner) {
            sections.addTeamMember = _jsx('div', {}, void 0, sections.bucketUsage);
        }

        if (this.state.editTeamName) {
            sections.editTeamName = _jsx('form', {
                onSubmit: this.saveTeamName,
                className: 'edit-team-title-form'
            }, void 0, _react2['default'].createElement('input', { type: 'text', ref: 'teamNameInput', defaultValue: this.state.team.name }), _jsx(_button2['default'], {
                buttonText: 'Save',
                onClick: this.saveTeamName,
                buttonColor: 'grasshopper',
                buttonHoverColor: 'ashen',
                buttonClass: 'm-button-butmit',
                buttonHoverTextColor: 'white'
            }));
        } else {
            sections.editTeamName = _jsx('h1', {}, void 0, _jsx('span', {
                id: 'team_name'
            }, void 0, this.state.team.name || "Untitled Team"), sections.editTeamName);
        }

        if (this.state.error) {
            sections.error = _jsx('div', {
                id: 'error_container'
            }, void 0, _jsx('label', {
                htmlFor: 'new_member_email_address',
                generated: 'true',
                className: 'error'
            }, void 0, this.state.error.message));
        }

        sections.teamMembers = this.state.teamMembers.map(function (teamMember, i) {
            return _jsx(_member2['default'], {
                member: teamMember,
                teamMembers: this.state.teamMembers
            }, teamMember.emailAddress + i);
        }.bind(this));

        return _jsx('div', {
            className: 'team-page'
        }, void 0, _jsx('div', {
            className: "team-accounts-column " + (_hfReactHelper2['default'].isHelloSign() ? "hs" : "hf")
        }, void 0, sections.editTeamName, sections.addTeamMember, sections.error, _jsx('div', {
            id: 'team_list_header'
        }, void 0, _jsx('div', {
            id: 'member_email'
        }, void 0, 'Member Email'), _jsx('div', {
            id: 'role'
        }, void 0, 'Role'), _hfReactHelper2['default'].isHelloSign() ? _jsx('div', {
            id: 'templates'
        }, void 0, 'Templates Owned') : void 0), _jsx('div', {
            id: 'team_list_container'
        }, void 0, _jsx('table', {
            className: 'team_list'
        }, void 0, _jsx('tbody', {}, void 0, sections.teamMembers)))));
    }
});

module.exports = TeamPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/index.jsx
 ** module id = 717
 ** module chunks = 0
 **/